import { useEffect, useState } from 'react';
import { getDataPrivacySettings } from '../../api/subscriptions';
const DEFAULT_SETTINGS = {
  value: undefined,
  loading: true,
  error: null
};
let gdprToggleEnabledGlobal = DEFAULT_SETTINGS;

// TODO: This should not be cached like this
export const __TEST_ONLY_RESET_CACHE__ = () => {
  gdprToggleEnabledGlobal = DEFAULT_SETTINGS;
};
export const useIsGdprToggleEnabled = () => {
  const [gdprToggleEnabledSettings, setGdprToggleEnabledSettings] = useState(gdprToggleEnabledGlobal);
  useEffect(() => {
    if (gdprToggleEnabledGlobal === DEFAULT_SETTINGS) {
      getDataPrivacySettings().then(res => {
        const dataPrivacySettings = res;
        gdprToggleEnabledGlobal = {
          value: dataPrivacySettings.gdprToggleEnabled,
          loading: false,
          error: null
        };
        setGdprToggleEnabledSettings(gdprToggleEnabledGlobal);
      }).catch(e => {
        gdprToggleEnabledGlobal = {
          value: undefined,
          loading: false,
          error: e
        };
        setGdprToggleEnabledSettings(gdprToggleEnabledGlobal);
      });
    }
  });
  return gdprToggleEnabledSettings;
};
export const resetGdprToggleGlobalDefaultSettings = () => {
  gdprToggleEnabledGlobal = DEFAULT_SETTINGS;
};